import { replaceTemplateVariables } from './utils/replace-template-variables';

function generateCallsign(unit, template) {
  const isCombined = !("citizenId" in unit) || "officers" in unit || "deputies" in unit;
  const _template = getTemplateFromUnit({ template, unit });
  if (isCombined && unit.userDefinedCallsign) {
    return unit.userDefinedCallsign;
  }
  const unitDivision = "divisions" in unit ? unit.divisions : "division" in unit ? unit.division : [];
  const [division] = Array.isArray(unitDivision) ? unitDivision : [unitDivision];
  if (!_template) {
    return "";
  }
  const replacers = {
    department: unit.department?.callsign,
    callsign: unit.callsign,
    callsign1: unit.callsign,
    callsign2: unit.callsign2,
    division: division?.callsign,
    incremental: unit.incremental
  };
  return replaceTemplateVariables(_template, replacers);
}
function getTemplateFromUnit({ unit, template }) {
  const isCombined = !("citizenId" in unit) || "officers" in unit || "deputies" in unit;
  if (isCombined) {
    return unit.userDefinedCallsign || unit.pairedUnitTemplate || template;
  }
  return unit.userDefinedCallsign || unit.department?.customTemplate || template;
}

export { generateCallsign };
